import * as uuid from "uuid";

import { RateData } from "@/features/LiveFormEditor/Steps/StepTickets/Rates/types";

const DEFAULT_MAXIMUM_TO_BUY_PER_ORDER = 10;

export const buildDefaultAddOn = (): RateData => ({
  id: uuid.v4(),
  name: "",
  amount: undefined,
  description: "",
  isGroup: false,
  attendeesByTicket: null,
  isGeneratingReceipt: false,
  receiptEligibleAmount: null,
  seats: null,
  rateMinimumNumberToBuy: null,
  alreadyBoughtTicketsCount: undefined,
  rateMaximumNumberToBuy: DEFAULT_MAXIMUM_TO_BUY_PER_ORDER,
  membershipValidityPeriod: null,
  membershipValidityPeriodAtDate: undefined,
  allowAutomaticRenewal: false,
  isScheduled: false,
  salesStartMode: "formDefault" as const,
  salesStartDate: null,
  salesStartAfterRateId: null,
  salesEndMode: "formDefault" as const,
  salesEndDate: null,
  bidIncrement: undefined,
  photos: [{ photoUrl: null, id: uuid.v4() }],
  isPayWhatYouCan: false,
  payWhatYouCanMinimumAmount: null,
  payWhatYouCanSuggestedAmount: null,
  isMemberOnly: false,
  memberOnlyMembershipRateIds: [],
  isHidden: false,
  shopVariants: [],
  shopVariantsToDelete: [],
  categoryIds: [],
  taxIds: [],
});
